'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _commonFunc = require('appkit-react-utils/commonFunc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;

      onChange && onChange(e.target.value);
    };

    _this.handleFocus = function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) onFocus(e);
      _this.setState({
        isFocus: true
      });
    };

    _this.handleBlur = function (e) {
      var onBlur = _this.props.onBlur;

      if (onBlur) onBlur(e);
      _this.setState({
        isFocus: false
      });
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          onEnterPress = _this$props.onEnterPress;

      onKeyDown && onKeyDown(e);
      // cope with Enter key action
      if (e.keyCode === 13) {
        onEnterPress && onEnterPress(e.target.value, e);
      }
    };

    _this.state = {
      isFocus: false
    };
    return _this;
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _ClassNames3;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          value = _props.value,
          label = _props.label,
          _props$readonly = _props.readonly,
          readonly = _props$readonly === undefined ? false : _props$readonly,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          _props$inputBoxSize = _props.inputBoxSize,
          inputBoxSize = _props$inputBoxSize === undefined ? 'sm' : _props$inputBoxSize,
          hasError = _props.hasError,
          errMsg = _props.errMsg,
          addonBefore = _props.addonBefore,
          addonAfter = _props.addonAfter,
          prefix = _props.prefix,
          suffix = _props.suffix,
          onChange = _props.onChange,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onEnterPress = _props.onEnterPress,
          onKeyDown = _props.onKeyDown,
          className = _props.className,
          style = _props.style,
          htmlFor = _props.htmlFor,
          otherProps = _objectWithoutProperties(_props, ['defaultValue', 'value', 'label', 'readonly', 'disabled', 'inputBoxSize', 'hasError', 'errMsg', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'onChange', 'onBlur', 'onFocus', 'onEnterPress', 'onKeyDown', 'className', 'style', 'htmlFor']);

      var inputPrefix = 'a-input';
      var inputWrapperClasses = (0, _classnames2.default)(className, _defineProperty({}, 'a-input-size-' + inputBoxSize, inputBoxSize));
      var inputClasses = (0, _classnames2.default)('a-input-text', _defineProperty({}, 'a-input-error', hasError));
      var compoundInputClasses = (0, _classnames2.default)('a-input-compound', (_ClassNames3 = {}, _defineProperty(_ClassNames3, 'a-input-prefix-container', prefix), _defineProperty(_ClassNames3, 'a-input-suffix-container', suffix), _ClassNames3));

      var prefixCn = (0, _classnames2.default)(inputPrefix + '-prefix', 'a-input-prefix-' + (this.state.isFocus ? "focus" : "unfocus"));

      var fieldId = htmlFor || (0, _commonFunc.guid)();

      return React.createElement(
        'div',
        { className: inputWrapperClasses, style: style },
        label && React.createElement(
          'label',
          { htmlFor: fieldId, className: 'a-form-label' },
          label
        ),
        addonBefore,
        React.createElement(
          'div',
          { className: compoundInputClasses },
          prefix && React.createElement(
            'div',
            { className: prefixCn },
            prefix
          ),
          React.createElement('input', Object.assign({
            className: inputClasses,
            defaultValue: defaultValue,
            value: value,
            readOnly: readonly,
            disabled: disabled,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyDown: this.handleKeyDown.bind(this),
            'aria-label': fieldId
          }, otherProps)),
          suffix && React.createElement(
            'div',
            { className: inputPrefix + '-suffix' },
            suffix
          )
        ),
        addonAfter,
        hasError && React.createElement(
          'p',
          { className: 'a-form-error' },
          errMsg
        )
      );
    }
  }]);

  return Input;
}(React.Component);

exports.default = Input;


Input.propTypes = {
  defaultValue: _propTypes2.default.string,
  value: _propTypes2.default.string,
  label: _propTypes2.default.node,
  readonly: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  // customize input stying
  inputBoxSize: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  errMsg: _propTypes2.default.string,
  // event hooks
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onEnterPress: _propTypes2.default.func,
  // optional Input addons
  addonBefore: _propTypes2.default.any,
  addonAfter: _propTypes2.default.any,
  prefix: _propTypes2.default.any,
  suffix: _propTypes2.default.any
};